import { useEffect, useRef, useState } from "react";
import domain from "../reusecomponent/domain";
import { getToken } from "../whatsapp/function/token";
import BlankLoader from "../CommerceManager/component/BlankLoader";
import Loader from "../CommerceManager/component/Loader";
import { ErrorToastContainer } from "../whatsapp/function/CustomFunction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const GmbManager = () => {
  const locationsRef = useRef([]);
  const [blankloading, setBlankLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setBlankLoading(true);
    const token = getToken();
    const res = await fetch(`${domain()}/gmb/gmb_list`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const json = await res.json();
    if (json.status && Array.isArray(json.data)) locationsRef.current = json.data;
    setBlankLoading(false);
  };

  const downloadQR = async (storeCode) => {
    try{
        setLoading(true);

        const myHeaders = new Headers();
        const formdata = new FormData();
        const access_token = getToken();
        
        myHeaders.append(`Authorization`, `Bearer ${access_token}`);
        formdata.append("store_code",storeCode);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow"
        };
        const res = await fetch(`${domain()}/gmb/gmb_business/qr_download`, requestOptions)

        if(res.ok){
            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.href = url;
            a.download = `${storeCode}.png`; // filename
            document.body.appendChild(a);
            a.click();

            a.remove();
            window.URL.revokeObjectURL(url);
        }else{
          const result = await res.json();
          ErrorToastContainer(result.message);
        }
    }catch(e){
      ErrorToastContainer("Internal server problem");
    }finally{
        setLoading(false);
    }
  };

  return (
    <div className="card p-3" style={{overflow: "auto"}}>
      {blankloading && <BlankLoader />}
      {loading && <Loader />}
      <h5 className="mb-3">📍 GMB Location Manager</h5>

      <table className="table table-hover align-middle">
        <thead className="table-light">
          <tr>
            <th>Business</th>
            <th>Store Code</th>
            <th>View Business</th>
            <th>Go Profile</th>
            <th>Download QR</th>
            <th>Action</th>
            <th>Expire Date</th>
          </tr>
        </thead>

        <tbody>
          {Array.isArray(locationsRef.current) && locationsRef.current.map((loc, i) => {
            const title = loc?.title || "";
            const website = loc?.websiteUri || "";
            return (
              <tr key={i}>
                <td className="d-flex align-items-center gap-2" style={{cursor: "pointer"}} onClick={()=>{

                }}>
                  <Avatar title={title} image={loc?.profile_picture} />
                  <div>
                    <strong>{title.length > 25 ? title.slice(0, 25) + "..." : title || "—"}</strong>
                    {website ? (
                      <>
                        <br/>
                        <a target="_blank" rel="noreferrer" href={website}>
                          {website.length > 25 ? website.slice(0, 25) + "..." : website}
                        </a>
                      </>
                    ) : null}
                  </div>
                </td>

                <td>{loc?.storeCode || "—"}</td>

                <td>
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => setModalData(loc)}
                  >
                    View
                  </button>
                </td>
                <td>
                  {loc?.mapsUri ? (
                    <button onClick={() => window.open(loc.mapsUri, "_blank")} className="btn d-inline-flex align-items-center gap-2" style={{ background: "#fff", border: "1px solid #dadce0", color: "#1a73e8", fontWeight: 500, fontSize: "14px", padding: "8px 14px", borderRadius: "8px" }} >
                      <img src="https://www.gstatic.com/images/branding/product/1x/gsa_512dp.png" alt="Google" style={{ width: "18px", height: "18px" }} /> See your profile
                    </button>
                  ) : "—"}
                </td>
                <td>
                  <button
                    className="btn btn-outline-success btn-sm"
                    onClick={() => downloadQR(loc?.storeCode)}
                    disabled={!loc?.storeCode}
                  >
                    QR Code
                  </button>
                </td>
                <td>
                  {loc?.storeCode && (
                    <Link to={`/client-area/gmb/action/${btoa(loc.storeCode)}`}>
                      <FontAwesomeIcon icon={faGear} />
                    </Link>
                  )}
                </td>
                <td>{loc?.expire_date || "—"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <ProfileModal
        show={!!modalData}
        data={modalData}
        onClose={() => setModalData(null)}
      />
    </div>
  );
};

export default GmbManager;


export const Avatar = ({ title, image }) => {
  const firstLetter = title?.charAt(0).toUpperCase() || "?";
  const [imgError, setImgError] = useState(false);

  if (!image || imgError) {
    return (
      <div
        className="rounded-circle d-flex align-items-center justify-content-center fw-semibold text-white"
        style={{
          width: "36px",
          height: "36px",
          backgroundColor: "#1a73e8",
        }}
      >
        {firstLetter}
      </div>
    );
  }

  return (
    <img
      src={image}
      alt={title}
      className="rounded-circle"
      style={{ width: "36px", height: "36px", objectFit: "cover" }}
      onError={() => setImgError(true)}
    />
  );
};

const ProfileModal = ({ show, onClose, data }) => {
  const [loader, setLoader] = useState(false);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!show || !data?.storeCode) return;

    const fetchData = async () => {
      try {
        setLoader(true);
        const token = getToken();

        const res = await fetch(
          `${domain()}/gmb/gmb_business/${btoa(data.storeCode)}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const json = await res.json();

        if (json.status) {
          setDetails(json.data);
        } else {
          onClose();
          ErrorToastContainer(json.message);
        }
      } catch (e) {
        onClose();
        ErrorToastContainer("Internal server problem");
      } finally {
        setLoader(false);
  
      }
    };

    fetchData();
  }, [show, data?.storeCode]);

  if (!show) return null;

  // 🔹 Safe JSON parse helper
  const parseJSON = (value) => {
    try {
      return typeof value === "string" ? JSON.parse(value) : value;
    } catch {
      return null;
    }
  };

  const phone = parseJSON(details?.phoneNumbers);
  const address = parseJSON(details?.storefrontAddress);
  const services = parseJSON(details?.serviceTypes);
  const hours = parseJSON(details?.regularHours);

  const formatTime = (h) => {
    if (h === undefined || h === null) return "—";
    const hour = h % 12 || 12;
    const ampm = h >= 12 ? "PM" : "AM";
    return `${hour} ${ampm}`;
  };

  const formatHours = (item) => {
    return `${item.openDay}: ${formatTime(item.openTime?.hours)} - ${formatTime(item.closeTime?.hours)}`;
  };



  return (
    <div
      className="modal fade show d-flex align-items-center justify-content-center"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog" style={{ maxWidth: "620px", width: "100%"}}>
        <div className="modal-content rounded-3 shadow" style={{maxHeight: "80vh",overflowX: "auto"}}>

          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title mx-auto">Business Profile</h5>
            <button className="btn-close position-absolute end-0 me-3" onClick={onClose} />
          </div>

          {/* Loader */}
          {loader && (
            <div className="text-center my-4">
              <div className="spinner-border" style={{ color: "#075e54" }} />
            </div>
          )}

          {/* Body */}
          {!loader && details && (
            <div className="modal-body text-center">

              {/* Profile header */}
              <div className="d-flex flex-column align-items-center mb-4">
                <Avatar title={details.title} image={details.profile_picture} />
                <h6 className="mt-2 mb-0">{details.title}</h6>
                <small className="text-muted">{details.storeCode}</small>
              </div>

              {/* Details */}
              <div className="container-fluid text-start">

                {/* Store Code */}
                <Row label="Store Code" value={details.storeCode} />

                {/* Website */}
                {details.websiteUri && (
                  <Row
                    label="Website"
                    value={
                      <a href={details.websiteUri} target="_blank" rel="noreferrer">
                        {details.websiteUri}
                      </a>
                    }
                  />
                )}

                {/* Google Profile */}
                {details.mapsUri && (
                  <Row
                    label="Google Profile"
                    value={
                      <a href={details.mapsUri} target="_blank" rel="noreferrer">
                        View on Google
                      </a>
                    }
                  />
                )}

                {/* Phone */}
                {phone?.primaryPhone && (
                  <Row label="Phone" value={phone.primaryPhone} />
                )}

                {/* Address */}
                {address && (
                  <Row
                    label="Address"
                    value={`${address.addressLines?.join(", ")}, ${address.locality}, ${address.administrativeArea} - ${address.postalCode}`}
                  />
                )}

                {/* Category */}
                {details.categories && (
                  <Row label="Category" value={details.categories} />
                )}

                {/* Description */}
                {details.description && (
                  <Row label="Description" value={details.description} />
                )}

                {/* Services */}
                {Array.isArray(services) && (
                  <Row
                    label="Services"
                    value={
                      <ul className="mb-0">
                        {services.map((s, i) => (
                          <li key={i}>{s.displayName}</li>
                        ))}
                      </ul>
                    }
                  />
                )}

                {/* Business Hours*/}
                {Array.isArray(hours) && hours.length > 0 && (
                  <Row
                    label="Business Hours"
                    value={
                      <ul className="mb-0">
                        {hours.map((h, i) => (
                          <li key={i}>{formatHours(h)}</li>
                        ))}
                      </ul>
                    }
                  />
                )}

                {/* Expire */}
                <Row label="Expire Date" value={details.expire_date} />
              </div>
            </div>
          )}

          {/* Footer */}
          <div className="modal-footer justify-content-center">
            <button className="btn btn-secondary px-4" onClick={onClose}>
              Close
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

const Row = ({ label, value }) => (
  <div className="row py-2 border-bottom align-items-start">
    <div className="col-4 fw-semibold text-muted">{label}</div>
    <div className="col-8">{value}</div>
  </div>
);